import { defineFcm } from '../shared/factory';

export const FCM_PSF_REASON_FOR_SIGNING = defineFcm('psf_reason_for_signing').asBoolean().withDefault(false).toConfig();
